import { useEffect, useState } from 'react';

/**
 * Re-renders the calling component every `intervalMs` while mounted, returning
 * the current timestamp. Used to keep time-window gating (enabled/disabled by
 * schedule) reactive without requiring user interaction to re-render.
 */
export function useTickingNow(intervalMs = 5000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
